import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setPasswordChangedSuccess } from "../../redux/slices/passwordChangedSlice";
import { Input, Button, Alert, Card } from "antd";
import { LockOutlined, CheckCircleFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./ChangePassword.css";
import Layout from "../../component/Layout";
import Footer from "../../components/Footer/Footer";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const userEmail = localStorage.getItem("userEmail");
  const firstLogin = JSON.parse(localStorage.getItem("firstLogin")); // Check if user is forced to change password

  // ✅ Password Validation Rules
  const passwordCriteria = [
    { label: "At least 8 characters", check: newPassword.length >= 8 },
    { label: "One uppercase & lowercase letter", check: /[A-Z]/.test(newPassword) && /[a-z]/.test(newPassword) },
    { label: "One number", check: /\d/.test(newPassword) },
    { label: "One special character (@, $, !, %, *, ?, &)", check: /[@$!%*?&]/.test(newPassword) }
  ];

  const isValidPassword = passwordCriteria.every((item) => item.check);

  const handleSubmit = async () => {
    setPasswordError(null);
    setSuccessMessage(null);

    if (!currentPassword || !newPassword || !confirmPassword) {
      setPasswordError("Please fill in all fields.");
      return;
    }

    if (currentPassword === newPassword) {
      setPasswordError("New password cannot be the same as the old password.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setPasswordError("Passwords do not match.");
      return;
    }

    if (!isValidPassword) {
      setPasswordError("Please meet all password requirements before submitting.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`http://localhost:8080/auth/change-password?email=${userEmail}&newPassword=${newPassword}`, {
        method: "POST",
        headers: { "Authorization": `Bearer ${token}` }
      });

      if (!response.ok) {
        throw new Error("Failed to change password. Please try again.");
      }

      setSuccessMessage("Password updated successfully! Redirecting to login...");

      setTimeout(() => {
        dispatch(setPasswordChangedSuccess());
        localStorage.removeItem("firstLogin"); // ✅ Remove firstLogin flag after password update
        navigate("/login");
      }, 3000);
    } catch (error) {
      setPasswordError(error.message || "Failed to change password.");
    }
  };

  return firstLogin ? (
    <div className="change-password-container">
      <Card className="change-password-card">
        <h2 className="title">Change Your Password</h2>
        <p className="subtitle">Enter a new password for your account.</p>
        <div className="message-container">
          {successMessage && <Alert message={successMessage} type="success" showIcon />}
          {passwordError && <Alert message={passwordError} type="error" showIcon />}
        </div>
        <Input.Password className="password-input" size="large" placeholder="Current Password" prefix={<LockOutlined />} value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} />
        <Input.Password className="password-input" size="large" placeholder="New Password" prefix={<LockOutlined />} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
        <div className="password-criteria">
          {passwordCriteria.map((item, index) => (
            <p key={index} className={item.check ? "valid" : "pending"}>
              <CheckCircleFilled className={`check-icon ${item.check ? "checked" : ""}`} /> {item.label}
            </p>
          ))}
        </div>
        <Input.Password className="password-input" size="large" placeholder="Confirm New Password" prefix={<LockOutlined />} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
        <Button className="submit-button" type="primary" onClick={handleSubmit}>Change Password</Button>
      </Card>
      <Footer /> {/* ✅ Only Footer, No Sidebar/Header */}
    </div>
  ) : (
    <Layout>
      <div className="change-password-container">
        <Card className="change-password-card">
          <h2 className="title">Change Your Password</h2>
          <p className="subtitle">Enter a new password for your account.</p>
          <div className="message-container">
            {successMessage && <Alert message={successMessage} type="success" showIcon />}
            {passwordError && <Alert message={passwordError} type="error" showIcon />}
          </div>
          <Input.Password className="password-input" size="large" placeholder="Current Password" prefix={<LockOutlined />} value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} />
          <Input.Password className="password-input" size="large" placeholder="New Password" prefix={<LockOutlined />} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
          <div className="password-criteria">
            {passwordCriteria.map((item, index) => (
              <p key={index} className={item.check ? "valid" : "pending"}>
                <CheckCircleFilled className={`check-icon ${item.check ? "checked" : ""}`} /> {item.label}
              </p>
            ))}
          </div>
          <Input.Password className="password-input" size="large" placeholder="Confirm New Password" prefix={<LockOutlined />} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
          <Button className="submit-button" type="primary" onClick={handleSubmit}>Change Password</Button>
        </Card>
      </div>
    </Layout>
  );
};

export default ChangePassword;
